import { observable } from 'mobx';
import { LicenceSchema } from '../../../types/schema';
import { PaginationMeta } from '../../../types';
import { LicenceSortType, LicenceStatus, SortOrder } from '../../../components/project-happy/utilities/types';

export class AccountLicencesPageModel {
  @observable
  loading = true;

  @observable
  loadingMore = false;

  @observable
  licences: Array<LicenceSchema> = [];

  @observable
  pagination: PaginationMeta;

  @observable
  sortType: LicenceSortType = 'date';

  @observable
  dateOrder: SortOrder = 'desc';

  @observable
  channelId: string | null = null;

  @observable
  status: LicenceStatus = null;

  @observable
  page = 1;

  @observable
  i18n: any = {};
}
